// Layout.jsx
import React from "react";
import Footer from "./Footer";
import Header from "./Header";

export function FooterLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 relative">
      <div className="absolute inset-0 z-0 pointer-events-none bg-[radial-gradient(#cbd5e1_1px,transparent_1px)] [background-size:24px_24px] opacity-50"></div>
      <div className="relative z-10 flex flex-col flex-grow">
        {children}
      </div>
      <Footer />
    </div>
  );
}

export function HeaderLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 relative">
      <div className="absolute inset-0 z-0 pointer-events-none bg-[radial-gradient(#cbd5e1_1px,transparent_1px)] [background-size:24px_24px] opacity-50"></div>
      <div className="relative z-10 flex flex-col flex-grow">
        <Header />
        {children}
      </div>
    </div>
  );
}

export function HeaderFooterLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 relative">
      <div className="absolute inset-0 z-0 pointer-events-none bg-[radial-gradient(#cbd5e1_1px,transparent_1px)] [background-size:24px_24px] opacity-50"></div>
      <div className="relative z-10 flex flex-col flex-grow">
        <Header />
        <main className="flex-grow flex flex-col">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
}
